/** css */
import './CardTask.css';
import CardTask from './CardTask';

export default CardTask;
